import React, { useCallback } from "react";
import { useQuestionnaire } from "../../context/questionnaire";
import { Language } from "../../context/preferred-language";
import { GlobeIcon } from "../icons/globe";
import styled from "styled-components";

const LANGUAGE_OPTIONS: { value: Language; label: string }[] = [
  { value: Language.ENGLISH, label: "English" },
  { value: Language.SPANISH, label: "Español" },
  { value: Language.PORTUGUESE, label: "Português" },
];

const PickerWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;

  svg {
    width: 18px;
    height: 18px;
    fill: #6b6b76;
    flex-shrink: 0;
  }
`;

const Select = styled.select`
  appearance: none;
  background: transparent;
  border: none;
  font-family: var(--font-family-default);
  font-size: 14px;
  font-weight: 600;
  color: #4a4d5e;
  cursor: pointer;
  padding: 4px 16px 4px 0;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' fill='%236b6b76'%3E%3Cpath d='M0 0l5 6 5-6z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0 center;

  &:focus {
    outline: none;
  }
`;

export const QuestionnaireLanguagePicker: React.FC = () => {
  const { locale, changeLocale } = useQuestionnaire();

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      changeLocale(e.target.value);
    },
    [changeLocale],
  );

  return (
    <PickerWrapper>
      <GlobeIcon />
      <Select value={locale} onChange={handleChange} className="notranslate">
        {LANGUAGE_OPTIONS.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </Select>
    </PickerWrapper>
  );
};
